import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=315b61a7&scoped=true&"
import script from "./Error.vue?vue&type=script&lang=js&"
export * from "./Error.vue?vue&type=script&lang=js&"
import style0 from "./Error.vue?vue&type=style&index=0&id=315b61a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b61a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315b61a7')) {
      api.createRecord('315b61a7', component.options)
    } else {
      api.reload('315b61a7', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=315b61a7&scoped=true&", function () {
      api.rerender('315b61a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/Error.vue"
export default component.exports